import { apiJson } from "../utils/api.js";
import { handleApiError } from "../utils/errorHandler.js";

const BASE_URL = "/kms/partner-company";

/**
 * Company related service functions
 */
const companyService = {
    /**
     * Get list of manually managed companies (no integration-synced rows).
     */
    getCompanies: async () => {
        try {
            const response = await apiJson.get(BASE_URL);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Every company for this chef, including integration-synced ones.
     */
    getAllCompanies: async () => {
        try {
            const response = await apiJson.get(`${BASE_URL}/all`);
            return response.data;
        } catch (error) {
            handleApiError(error, { showToast: false });
            throw error;
        }
    },

    /**
     * Create a new company
     */
    createCompany: async (companyData) => {
        try {
            const response = await apiJson.post(BASE_URL, companyData);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Update an existing company
     */
    updateCompany: async (companyId, companyData) => {
        try {
            const response = await apiJson.put(`${BASE_URL}/${companyId}`, companyData);
            return response.data;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Get a company's schedule override
     * @returns {Promise<{ days: Array, leadTimeHours: number }>} empty days = uses chef's working days
     */
    getCompanySchedule: async (companyId) => {
        try {
            const response = await apiJson.get(`${BASE_URL}/${companyId}/schedule`);
            return response.data;
        } catch (error) {
            handleApiError(error, { showToast: false });
            throw error;
        }
    },

    /**
     * Replace a company's schedule override
     * @param {number} companyId
     * @param {{ days: Array<{ dayOfWeek: number, mode: "RANGE"|"SLOTS", timeFrom?: string, timeTo?: string, slots?: string[] }>, leadTimeHours: number }} schedule
     *        dayOfWeek is 1 (Monday) .. 7 (Sunday); empty days resets to the chef's working days
     */
    updateCompanySchedule: async (companyId, schedule) => {
        try {
            const response = await apiJson.put(`${BASE_URL}/${companyId}/schedule`, schedule);
            return response.data;
        } catch (error) {
            handleApiError(error, { showToast: false });
            throw error;
        }
    },

    /**
     * Delete a company
     */
    deleteCompany: async (companyId) => {
        try {
            await apiJson.delete(`${BASE_URL}/${companyId}`);
            return true;
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    }
};

export default companyService;
